import { mergeAppSettingsColorsToStyleParamsColors } from './mergeColors';
import { mergeAppSettingsNumbersToStyleParamsNumbers } from './mergeNumbers';
import { mergeAppSettingsNumbersToStyleParamsFonts } from './mergeFonts';
import { getPresetId } from './utils';
import { applyOpacityOnStyleParamsColors } from './mergeOpacity';
export const overrideServiceListStyleParams = _ref => {
  let {
    appSettings,
    styleParams,
    anywhereThemeOverride,
    isResponsive,
    tpaData,
    mergeOpacityToColor = false,
    fixLegacyFonts = false
  } = _ref;
  if (appSettings) {
    // @ts-expect-error
    styleParams = mapAppSettingsToStyleParams(appSettings, styleParams, anywhereThemeOverride, mergeOpacityToColor, fixLegacyFonts);
  }
  const presetId = getPresetId(isResponsive, tpaData);
  // @ts-expect-error
  styleParams = mergePresetIdToStyleParams(styleParams, presetId);
  return styleParams;
};
const mapAppSettingsToStyleParams = (appSettings, stylesParams, anywhereThemeOverride, mergeOpacityToColor, fixLegacyFonts) => {
  const styleParamsColorsWithOpacity = applyOpacityOnStyleParamsColors(appSettings, stylesParams);
  appSettings = {
    ...appSettings,
    ...(anywhereThemeOverride ? {} : styleParamsColorsWithOpacity),
    // for ADI
    ...(anywhereThemeOverride ? {} : stylesParams.fonts) // for ADI
  };

  const colors = mergeAppSettingsColorsToStyleParamsColors(appSettings, mergeOpacityToColor);
  const numbers = mergeAppSettingsNumbersToStyleParamsNumbers(appSettings);
  const fonts = mergeAppSettingsNumbersToStyleParamsFonts(appSettings, fixLegacyFonts);
  return {
    colors,
    numbers,
    fonts
  };
};
const mergePresetIdToStyleParams = (stylesParams, presetId) => {
  return {
    ...stylesParams,
    numbers: {
      ...stylesParams.numbers,
      presetId
    }
  };
};
//# sourceMappingURL=overrideServiceListStyleParams.js.map